import React from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {images} from '../../../../../assets/icons';
import {useStyles} from '../../../../hooks/styles';
import {Screens} from '../../../../routing';
import {DropdownMenu} from '../dropdownMenu';
import {NotificationWidget} from '../notificationWidget';
import {ProfileWidget} from '../profileWidget';
import {DropdownMenuItem, DropdownMenuItemTypes} from '../dropdownMenu/model';
import {useSelector} from 'react-redux';
import {useLogoutDialog} from '../../../../hooks/useLogoutDialog';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';
import {UnreadNotificationsCounter} from '../../../counter';

export default () => {
  const navigation = useNavigation();
  const {visuallyImpaired} = useSelector(themeSelector());
  const logoutDialog = useLogoutDialog();

  const styles = useStyles(({theme}) => ({
    splitter: {
      width: 1,
      height: 18,
      alignSelf: 'center',
      marginLeft: 22,
      backgroundColor: theme.header.topLineColor,
    },
    counter: {
      left: 20,
      marginRight: 20,
      bottom: 3,
    },
    notifications: {
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
    },
    header: {
      minWidth: 96,
      paddingRight: 48,
    },
  }));

  const dropdownItems = React.useMemo(() => {
    const items: DropdownMenuItem[] = [
      {
        label: 'Профиль',
        onPress: () => {
          navigation.navigate(Screens.DesktopProfileMe);
        },
      },
      {
        label: 'Настройки',
        onPress: () => {
          navigation.navigate(Screens.DesktopProfileSettings);
        },
      },
      {
        label: 'Мои заявления',
        onPress: () => {
          navigation.navigate(Screens.ProfileApplications);
        },
      },
    ];
    if (visuallyImpaired) {
      items.push({
        label: 'Уведомления',
        onPress: () => navigation.navigate(Screens.Notifications),
        icon: () => <UnreadNotificationsCounter style={styles.counter} />,
        style: styles.notifications,
      });
    }
    items.push({
      type: DropdownMenuItemTypes.splitter,
    });
    items.push({
      label: 'Выйти',
      onPress: logoutDialog,
      icon: visuallyImpaired ? undefined : images.SignOut,
      style: {paddingTop: 4, paddingBottom: 5},
    });
    return items;
  }, [visuallyImpaired]);

  return (
    <>
      {!visuallyImpaired && (
        <>
          <NotificationWidget navigation={navigation} />
          <View style={styles.splitter} />
        </>
      )}
      <DropdownMenu items={dropdownItems} style={styles.header}>
        <ProfileWidget />
      </DropdownMenu>
    </>
  );
};
